import { PaymentInput } from "kubra-ux-forge";
import React from "react";
import { useField } from "formik";
import { withHiddenDescription } from "components/extension-fields/with-hidden-description";

const AccessiblePaymentInput = withHiddenDescription(PaymentInput);

interface PaymentAmountFieldProps {
  name: string;
  label?: string;
  instructionText?: string;
  minPayableAmount?: number;
  maxPayableAmount?: number;
  placeholder?: string;
}

export const PaymentAmountField: React.FC<PaymentAmountFieldProps> = ({
  name,
  label,
  instructionText,
  minPayableAmount,
  maxPayableAmount,
  placeholder,
}) => {
  const [field, meta] = useField(name);

  return (
    <div className="ez-pay-payable-row">
      <AccessiblePaymentInput
        dataCy="payment-amount-input"
        name={field.name}
        aria-required="true"
        label={label}
        defaultValue={minPayableAmount}
        placeholder={placeholder}
        instructionText={instructionText}
        min={minPayableAmount ?? undefined}
        max={maxPayableAmount ?? undefined}
        onChange={(
          e: React.ChangeEvent<HTMLInputElement>,
          paymentValue: number,
        ) => {
          if (paymentValue) {
            e.target.value = paymentValue.toString();
          }
          field.onChange(e);
        }}
        onBlur={field.onBlur}
        hasError={!!meta.error}
        errorText={meta.error}
        aria-invalid={!!meta.error}
      />
    </div>
  );
};
